export default __webpack_public_path__ + "static/media/jpg.20e13158.svg";